import { Component } from "react";
import "../../Registration/SetPassWord/setPassWord.css";
import "../../Registration/MainRegister/mainRegister.css";
import "../../Registration/MPin/fourDigitMPin.css";
import { IoEyeOutline } from "react-icons/io5";
import { IoEyeOffOutline } from "react-icons/io5";
import axios from "../../../axios";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { BsDot } from "react-icons/bs";
import UpdateSuccessfully from "../ForgotPin/updateSucess";

class SetNewPassWord extends Component {
  constructor() {
    super();
    this.state = {
      value1: "",
      value2: "",
      password: "",
      showPassword: false,
      success: false,
    };

    this.handleChange1 = (event) => {
      this.setState({
        value1: event.target.value,
      });
    };

    this.handleChange2 = (event) => {
      this.setState({
        value2: event.target.value,
      });
    };
  }

  render() {
    let colour1 = "#666666",
      colour2 = "#666666",
      colour3 = "#666666",
      colour4 = "#666666",
      colour5 = "#666666",
      colour6 = "#666666",
      colour7 = true;
    if (this.state.value1.length >= "8") {
      colour1 = "#45BF55";
    }
    if (this.state.value1.match(/[A-Z]/)) {
      colour2 = "#45BF55";
    }
    if (this.state.value1.match(/[a-z]/)) {
      colour3 = "#45BF55";
    }
    if (this.state.value1.match(/[-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\]/)) {
      colour4 = "#45BF55";
    }
    if (this.state.value1 === this.state.value2 && this.state.value1 !== "") {
      colour5 = "#45BF55";
    }
    if (this.state.value1.match(/[0-9]/)) {
      colour6 = "#45BF55";
    }
    if (
      this.state.value1 === this.state.value2 &&
      this.state.value1 !== "" &&
      this.state.value2.match(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-’\/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\])[A-Za-z\d\-’\/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\]{8,}$/,
      )
    ) {
      colour7 = false;
    }

    function myFunction() {
      var x = document.getElementById("myId3");
      var y = document.getElementById("close_eye1");
      var Z = document.getElementById("open_eye");

      if (x.type === "password") {
        x.type = "text";
        y.style.display = "none";
        Z.style.direction = "block";
      } else {
        x.type = "password";
        y.style.display = "block";
        Z.style.direction = "none";
      }
    }

    function myFunction2() {
      var x = document.getElementById("myId2");
      var y = document.getElementById("close_eye2");
      var Z = document.getElementById("open_eye2");

      if (x.type === "password") {
        x.type = "text";
        y.style.display = "none";
        Z.style.direction = "block";
      } else {
        x.type = "password";
        y.style.display = "block";
        Z.style.direction = "none";
      }
    }

    const School_Id = JSON.parse(localStorage.getItem("School_id"));
    const passwordNew = this.state.value1;
    const passwordConfirm = this.state.value2;
    const schoolCode = localStorage.getItem("schoolCode");

    this.handleSubmit = async (e) => {
      e.preventDefault();

      let User = {
        user_id: School_Id,
        password: passwordConfirm,
        school_code: schoolCode,
      };

      if (passwordNew === passwordConfirm && passwordNew !== "") {
        try {
          const res = await axios.put(
            `/api/v1/teacherAuth/reset/password`,
            User,
          );
          if (res) {
            this.setState({ success: true });
          }
        } catch (error) {
          console.log(error);
        }
      }
    };

    return (
      <div className="TotalContainer">
        <div className="MainContainer col-12 p-0  d-md-flex ">
          <div className="banner_box col-md-3 col-12 p-0">
            <img
              className="banner_img "
              src="/Register-img/baner_img.jpg"
              alt="baner_img"
            ></img>
          </div>

          <div className="form_box col-md-9 col-12 p-0">
            <div>
              <div className="total_logo_regist">
                <img
                  className="logo_registration"
                  src="/Register-img/Register_logo.png"
                  alt="Register_logo"
                ></img>
              </div>
              <div className="title_regis">Set Password</div>

              <form>
                <div className="input_box2">
                  <input
                    id="myId3"
                    type="Password"
                    className="forgot_pass_input"
                    required
                    name="Password"
                    placeholder="Set Password"
                    value={this.state.value1}
                    onChange={this.handleChange1}
                    autocomplete="off"
                    maxLength={64}
                  ></input>

                  <span onClick={myFunction} className="Eye_login">
                    <IoEyeOutline id="open_eye" />
                    <IoEyeOffOutline id="close_eye1" />
                  </span>
                </div>

                <div className="input_box2 ">
                  <input
                    id="myId2"
                    type="Password"
                    className="forgot_pass_input"
                    required
                    name="confirm Password"
                    placeholder="Confirm Password"
                    autocomplete="off"
                    value={this.state.value2}
                    onChange={this.handleChange2}
                    maxLength={64}
                  ></input>
                  <span onClick={myFunction2} className="Eye_login">
                    <IoEyeOutline id="open_eye2" />
                    <IoEyeOffOutline id="close_eye2" />
                  </span>
                </div>

                {this.state.value1 && (
                  <div className="mt-2">
                    <div className="error_msg_password">
                      <div>
                        <div style={{ color: colour1, fontSize: "12px" }}>
                          {" "}
                          <BsDot /> minimum 8 characters &nbsp;
                        </div>
                        <div style={{ color: colour2, fontSize: "12px" }}>
                          {" "}
                          <BsDot /> one uppercase letter
                        </div>
                      </div>
                      <div>
                        <div style={{ color: colour3, fontSize: "12px" }}>
                          {" "}
                          <BsDot /> one lowercase letter
                        </div>
                        <div style={{ color: colour6, fontSize: "12px" }}>
                          <BsDot /> one number{" "}
                        </div>
                      </div>
                    </div>
                    <div style={{ color: colour4, fontSize: "12px" }}>
                      <BsDot /> special character
                    </div>
                    <div style={{ color: colour5, fontSize: "12px" }}>
                      <BsDot /> Password & Confirm Password Match
                    </div>
                  </div>
                )}

                <div>
                  <button
                    class="btn btn"
                    disabled={colour7}
                    onClick={this.handleSubmit}
                    id={colour7 ? "btn_disabled" : "Register_continue_btn"}
                    type="button"
                  >
                    Continue
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {this.state.success && <UpdateSuccessfully type={"password"} />}
      </div>
    );
  }
}
export default SetNewPassWord;
